<template>
  <div
      v-on:click.self="expanded = false"
  >
    <div v-bind:class="{'expanded-content': expanded}">
      <a v-if="!expanded" title="Reset" href="./?mcd=0" class="about no-print">
        <font-awesome-icon icon="redo"/>
      </a>
      <AboutPage class="no-print"/>
      <div class="group no-print">
        <div class="control-title">Choose Geography:</div>
        <select name="geotypes" id="geotypes" v-model="geotype_local">
          <option value="Choose a geography" disabled> Choose a geography</option>
          <option v-bind:key="type" v-for="type in Object.keys(geotypes)" v-bind:value="type">
            {{ geotypes[type].name }}
          </option>
        </select>
      </div>
      <div class="group no-print">
        <div v-if="geotype === 'tracts' || geotype === 'blocks' || geotype === 'blockgroups'" class="control-title">
          Filter {{ geotypes[geotype].name }} by Community:
        </div>
        <div v-if="geotype === 'mcds' || geotype === 'schooldistricts'" class="control-title">Filter
          {{ geotypes[geotype].name }}:
        </div>
        <mcdSelect
            v-if="geotype === 'mcds' || geotype === 'tracts' || geotype === 'blocks' || geotype === 'blockgroups'"
            v-bind:mcd="mcd"
            v-bind:counties="counties"
            v-on:mcdInput="setMcd($event)"
            v-on:countiesInput="setCounties($event)"
        />
        <schoolDistrictSelect
            v-if="geotype === 'schooldistricts'"
            v-bind:mcd="schooldistricts"
            v-bind:counties="isds"
            v-on:schoolDistrictInput="$emit('schoolDistrictInput', $event)"
            v-on:isdsInput="$emit('isdsInput', $event)"
        />
      </div>
      <div style="padding-left: 8px">
        <a class="bar" v-if="downloadURL" v-bind:href='downloadURL'>
          <button style='padding-top: 3px' class="bar" v-on:click="downloadURL = undefined">Download Census Data
          </button>
        </a>
        <div style="display: grid; grid-template-columns: auto 30% ; grid-template-rows: 1fr">
          <button :title="`Generates a ${downloadFormat} download based on the filters`"
                  style='padding-top: 3px; width: 100%' v-if="!downloadURL" v-on:click="downloadData()">
            <font-awesome-icon icon="file-download"/>
            Generate Download as
            <span style="display: inline-block; margin-left: 3px; position: relative; top: 3px;">
                  <div class="loader" v-if="!loaded">
                    <div class="CDB-LoaderIcon CDB-LoaderIcon--big">
                      <svg class="CDB-LoaderIcon-spinner" viewBox="0 0 50 50">
                        <circle class="CDB-LoaderIcon-path" cx="25" cy="25" r="20" fill="none"/>
                      </svg>
                    </div>
                  </div>
                </span>
          </button>
          <select v-if="!downloadURL" style="background: white; color: black" name="" id=""
                  v-model="downloadFormat">
            <option value="filegdb">File GDB</option>
            <option value="excel">Excel</option>
          </select>
        </div>
      </div>
      <div class="group" style="max-width: 400px">
        <div class="control-title">Choose Data:<span v-if="selectedAmenity !== 'All_Access_Points'"></span></div>
        <div class="name">
          <button
              v-for="name in amenities"
              v-on:click="selectedAmenity = name"
              v-bind:disabled="name === selectedAmenity"
              v-bind:class="{'workplace_button': name === 'Workplace'}"
              v-bind:key="name">
            <font-awesome-icon v-if="name==='Residence'" icon="home"/>
            {{ amenityNames[name].name }}
          </button>
        </div>
      </div>
      <div class="group" style="max-width: 400px">
        <div class="control-title">Choose Display Type:</div>
        <select name="DisplayType" id="DisplayType" v-model="displayType">
          <option value="percent">Density/Rate</option>
          <option value="total">Number</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import mcdSelect from "./mcdSelect";
import schoolDistrictSelect from "./schoolDistrictSelect";
import AboutPage from "./AboutPage";

export default {
  name: "AmenitySelect",
  components: {mcdSelect, AboutPage, schoolDistrictSelect},
  props: ['mappedAmenity', 'amenities', 'amenityNames', 'aggArea', 'aggIds', 'geoid', 'mcdFilter', 'counties', 'isds', 'schooldistricts', 'mcd', 'data_tables', 'data_table', 'geotype', 'geotypes', 'modeNames', 'demographicColumn', 'demographicColumns', 'startExpanded'],
  data: function () {
    return {
      selectedAmenity: this.mappedAmenity,
      expanded: this.startExpanded,
      displayType: 'percent',
      geotype_local: this.geotype || 'mcds',
      downloadURL: undefined,
      downloadReady: true,
      downloadFormat: 'filegdb',
      loaded: true,
    }
  },
  computed: {
    censusFeatureLayerCreateReplicaUrl: function () {
      return `https://services1.arcgis.com/xUx8EjNc6egUPYWh/arcgis/rest/services/${this.geotypes[this.geotype].table}/FeatureServer/createReplica`
    },
    filter: function () {
      let geoids = '1=1'
      if (Array.isArray(this.geoid) && this.geoid.length !== 0) {
        geoids = `semgeoid IN (${this.geoid.join(',')})`;
      } else if (this.geoid && this.geoid !== 0) {
        geoids = `semgeoid = ${this.geoid}`
      }
      if (this.mcdFilter && this.mcdFilter.length > 0) {
        geoids = `semgeoid IN (${this.mcdFilter.join(',')})`;
      }
      if (this.schooldistricts && this.schooldistricts.length > 0) {
        geoids = `semgeoid IN (${this.schooldistricts.join(',')})`;
      }
      if (this.aggArea) {
        geoids = `semgeoid IN (${this.aggIds.join(',')})`;
      }
      return geoids
    },
  },
  methods: {
    setMcd: function (id) {
      this.$emit('mcdInput', id)
    },
    setCounties: function (id) {
      this.$emit('countiesInput', id)
    },
    getDownloadURL: async function (url) {
      const rawResponse = await fetch(url + '?f=json');
      const content = await rawResponse.json();
      if (content.status === 'Failed') {
        alert('Generating Download Failed. Check Parameters.')
        console.log('Generating Download Failed. Check Parameters. ' + this.filter.where)
        return
      } else if (content.status !== 'Completed') {
        await this.getDownloadURL(url)
      } else {
        this.downloadURL = content.resultUrl
        this.loaded = true
      }
      console.log(content)
    },
    downloadData: async function () {
      this.downloadURL = undefined
      this.loaded = false
      let options = {
        replicaName: "test",
        layers: 0,
        layerQueries: `{"0":{"where":"${this.filter}"}}`, //update
        geometryType: "esriGeometryEnvelope",
        transportType: "esriTransportTypeUrl",
        returnAttachments: true,
        returnAttachmentsDataByUrl: true,
        async: true,
        syncModel: "none",
        targetType: "client",
        syncDirection: "bidirectional",
        attachmentsSyncDirection: "bidirectional",
        dataFormat: this.downloadFormat,
        f: "pjson"
      }
      const searchParams = new URLSearchParams(options);

      const rawResponse = await fetch(this.censusFeatureLayerCreateReplicaUrl, {
        method: "POST",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: searchParams
      });
      const content = await rawResponse.json();
      await this.getDownloadURL(content.statusUrl)
    },
  },
  watch: {
    mappedAmenity: function () {
      this.selectedAmenity = this.mappedAmenity
    },
    selectedAmenity: function () {
      this.$emit('input', this.selectedAmenity)
    },
    expanded: function () {
      this.$emit('expandedInput', this.expanded)
    },
    geotype_local: function () {
      this.$emit('geotype', this.geotype_local)
    },
    displayType: function () {
      this.$emit('displayType', this.displayType)
    },
  }
}
</script>

<style scoped>
select {
  border-color: #f3f3f3;
}

select:focus {
  outline: 0;
  border-color: black;
}

select {
  border-radius: 10px;
  min-width: 0;
}

select option {
  font-size: 1rem;
}

button {
  background: #888787;
  border: 1px solid #FFFFFF;
  border-radius: 5px;
  padding: 9px;
  color: white;
  font-size: 14px;
}

.workplace_button {
  padding: 5px;
}

button:hover {
  background: #1a2f0b;
}

button:disabled {
  background: #64983D;
  padding-bottom: 7px;
  border-bottom: 5px solid #000000;
}

.about {
  float: right;
  padding: 5px;
  color: black;
}

@media screen {
  div.expanded {
    position: fixed;
    background: rgba(46, 60, 67, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;
    opacity: 1;
    overflow: hidden;
    backdrop-filter: blur(35px);
  }

  .expanded-content {
    background: white;
    max-width: 60%;
    border: #fffcfc solid 2px;
    border-radius: 10px;
    padding: 10px 30px;
    max-height: 80%;
    overflow: auto;
  }
}

.control-title {
  font-weight: bold;
  font-size: large;
}

.slidecontainer {
  width: 100%;
}

.mode-ticks {
  display: grid;
  width: 100%;
  grid-template-columns: min-content min-content min-content min-content;
  justify-content: space-between;
  margin-bottom: -45px;
  padding: 0 calc(29px - .7em);
}

@media print {
  .slidecontainer > div {
    display: inline-block;
  }

  .mode-ticks {
    margin-bottom: 0;
    display: inline-block;
  }
}

.mode-ticks div {
  text-align: center;
  justify-self: center;
}


.loader {
  position: initial;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  opacity: 1;
  transition: opacity 300ms;
  pointer-events: none;
}

.CDB-LoaderIcon--big {
  width: 20px;
  height: 20px;
}

.CDB-LoaderIcon-spinner {
  width: 20px;
  height: 20px;
  animation: rotate 2s linear infinite;
}

.CDB-LoaderIcon-path {
  stroke: rgba(255, 255, 255, .88);
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
  stroke-width: 4px
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg)
  }
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 50px;
  border-radius: 20px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.5;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 0.3;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 58px;
  height: 65px;
  border-radius: 20px;
  background: #64983D;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 58px;
  height: 65px;
  border-radius: 20px;
  background: #64983D;
  cursor: pointer;
}

.amenityIcon {
  height: 35px;
  width: 35px;
  vertical-align: bottom;
  margin-left: 7px;
}

.mode-label {
  font-size: 0.5em
}

.result-button {
  float: right;
  height: 30px;
  background: rgba(100, 152, 61, 0.75);
  border-color: rgba(100, 152, 61, 0.75);
}

.group {
  padding: 5px;
}

@media print {
  .no-print {
    display: none;
  }
}

@media screen and (max-width: 800px) {
  .expanded-content {
    position: relative;
  }

  div.expanded {
    z-index: 33;
  }
}

@media screen and (max-width: 1000px) {
  .control-title {
    font-size: small;
    display: inline-block;
  }

  .expanded-content {
    max-width: 80%;
    max-height: 100%;
  }

}
</style>
